export default "__VITE_ASSET__lNVUGy1C__"